import styled from 'src/styles/theme';
import { ModalShareConfigurationDealerCodeStyled } from '../ModalShareConfigurationDealerCodeStyled';

export const ModalShareConfigurationDealerCodeStyledDS = styled(ModalShareConfigurationDealerCodeStyled)`
    .dropdown,
    input {
        border: 1px solid ${({ theme }) => theme.colors.grey11};
        &:disabled {
            background: ${({ theme }) => theme.colors.grey11};
        }
    }
    .share-wrapper {
        & > .dropdown {
            .Select__indicators {
                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.white};
                    }
                }
            }
        }

        .input-wrapper {
            .dropdown, 
            input {
                border-color: ${({ theme }) => theme.colors.black};
            }
        }

        .mandatory-description {
            color: ${({ theme }) => theme.colors.black};
        }

    }

    .Select__control {
        border: none;
        padding: 0;
    }
    
    .civilitySection {
        .check {
            border-color: ${({ theme }) => theme.colors.primary};
        }
    }
`;
